import { localStore } from './storage';

export const ACTING_AS_STORAGE_KEY = 'sih:actingAsHealthcareEntity';

export type ActingAsEntity = { id: string; name: string };

export function readActingAsEntity(): ActingAsEntity | null {
  const parsed = localStore.getJSON<unknown>(ACTING_AS_STORAGE_KEY, null);
  if (
    parsed &&
    typeof parsed === 'object' &&
    typeof (parsed as ActingAsEntity).id === 'string' &&
    typeof (parsed as ActingAsEntity).name === 'string'
  ) {
    return { id: (parsed as ActingAsEntity).id, name: (parsed as ActingAsEntity).name };
  }
  return null;
}

export function writeActingAsEntity(entity: ActingAsEntity | null): void {
  if (entity === null) {
    localStore.remove(ACTING_AS_STORAGE_KEY);
  } else {
    localStore.setJSON(ACTING_AS_STORAGE_KEY, entity);
  }
}
